import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enums";
import { IDashboardSettingsState } from "./dashboardSettings.types";
import {
  fetchMetricDefinitions,
  upsertMetricDefinition,
  fetchHabitationalMetricDefinitions,
  upsertHabitationalMetricDefinition,
} from "./dashboardSettingsThunk";

export const dashboardSettingsInitialState: IDashboardSettingsState = {
  plInsightBenchMark: {
    loading: LoadState.NotLoaded,
    error: null,
    data: [],
    totalRecords: 0,
  },
  habitationalBenchMark: {
    loading: LoadState.NotLoaded,
    error: null,
    data: [],
    totalRecords: 0,
  },
};

const dashboardSettingsSlice = createSlice({
  name: "dashboardSettings",
  initialState: dashboardSettingsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetchMetricDefinitions
    builder.addCase(fetchMetricDefinitions.pending, (state) => {
      state.plInsightBenchMark.loading = LoadState.InProgress;
      state.plInsightBenchMark.error = null;
    });
    builder.addCase(fetchMetricDefinitions.fulfilled, (state, action) => {
      state.plInsightBenchMark.loading = LoadState.Loaded;
      state.plInsightBenchMark.data = action.payload.data;
      state.plInsightBenchMark.totalRecords = action.payload.totalRecords;
      state.plInsightBenchMark.error = null;
    });
    builder.addCase(fetchMetricDefinitions.rejected, (state, action) => {
      state.plInsightBenchMark.loading = LoadState.Failed;
      state.plInsightBenchMark.error = action.payload as string;
    });
    // upsertMetricDefinition
    builder.addCase(upsertMetricDefinition.pending, (state) => {
      state.plInsightBenchMark.loading = LoadState.InProgress;
      state.plInsightBenchMark.error = null;
    });
    builder.addCase(upsertMetricDefinition.fulfilled, (state) => {
      state.plInsightBenchMark.loading = LoadState.Loaded;
      state.plInsightBenchMark.error = null;
    });
    builder.addCase(upsertMetricDefinition.rejected, (state, action) => {
      state.plInsightBenchMark.loading = LoadState.Failed;
      state.plInsightBenchMark.error = action.payload as string;
    });
    // fetchHabitationalMetricDefinitions
    builder.addCase(fetchHabitationalMetricDefinitions.pending, (state) => {
      state.habitationalBenchMark.loading = LoadState.InProgress;
      state.habitationalBenchMark.error = null;
    });
    builder.addCase(
      fetchHabitationalMetricDefinitions.fulfilled,
      (state, action) => {
        state.habitationalBenchMark.loading = LoadState.Loaded;
        state.habitationalBenchMark.data = action.payload.data;
        state.habitationalBenchMark.totalRecords = action.payload.totalRecords;
        state.habitationalBenchMark.error = null;
      },
    );
    builder.addCase(
      fetchHabitationalMetricDefinitions.rejected,
      (state, action) => {
        state.habitationalBenchMark.loading = LoadState.Failed;
        state.habitationalBenchMark.error = action.payload as string;
      },
    );
    // upsertHabitationalMetricDefinition
    builder.addCase(upsertHabitationalMetricDefinition.pending, (state) => {
      state.habitationalBenchMark.loading = LoadState.InProgress;
      state.habitationalBenchMark.error = null;
    });
    builder.addCase(
      upsertHabitationalMetricDefinition.fulfilled,
      (state) => {
        state.habitationalBenchMark.loading = LoadState.Loaded;
        state.habitationalBenchMark.error = null;
      },
    );
    builder.addCase(
      upsertHabitationalMetricDefinition.rejected,
      (state, action) => {
        state.habitationalBenchMark.loading = LoadState.Failed;
        state.habitationalBenchMark.error = action.payload as string;
      },
    );
  },
});

export default dashboardSettingsSlice.reducer;
